import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { LinkedPropertyUtility } from '@shared/utils/linked-property.utility';
import {
  AI_CHAT_INSTRUMENTATION_EVENTS,
  ClientInstrumentationEventType,
} from '@shared/interfaces/client-instrumentation.interface';
import { InstrumentationApi } from '../../services/rest/instrumentation.api';

@Injectable({ providedIn: 'root' })
export class AiChatInstrumentationService {
  constructor(
    private instrumentationApi: InstrumentationApi,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  async sendEvent(
    eventType: ClientInstrumentationEventType,
    sessionId: string,
    additionalProps: Record<string, unknown> = {},
  ): Promise<void> {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const { workspaceId, digitalPropertyId } = LinkedPropertyUtility.fromLinkedPropertyQueryParam(queryParams);
    await this.instrumentationApi
      .instrument(
        eventType,
        {
          chatSessionId: sessionId,
          page: this.router.url.split('?')[0],
          ...additionalProps,
        },
        workspaceId,
        digitalPropertyId,
      )
      .pipe(take(1))
      .toPromise();
  }

  sendDeleteEvent(sessionId: string): void {
    this.sendEvent(AI_CHAT_INSTRUMENTATION_EVENTS.DELETE_AI_CHAT, sessionId);
  }
}
